import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";
import axios from "axios";

import Category from "./Category";

const findIndex = (records, id) => {
  const opts = id.toString().includes("_") ? { _id: id } : { id: id };

  return lodash.findIndex(records, opts);
};

class Categories extends React.Component {
  state = { loading: false, categories: this.props.categories };

  handleChangeCategoryName = (id, name) => {
    const categories = this.state.categories;
    const idx = findIndex(categories, id);

    categories[idx].name = name;
    this.setState({ categories });
  };

  handleChangeSkillName = (categoryId, skillId, value) => {
    const categories = this.state.categories;
    const categoryIndex = findIndex(categories, categoryId);
    const skillIndex = findIndex(categories[categoryIndex].skills, skillId);

    categories[categoryIndex].skills[skillIndex].name = value;
    this.setState({ categories });
  };

  handleAddCategory = () => {
    const categories = this.state.categories;

    categories.push({ _id: `_${new Date().getTime()}`, name: "", skills: [] });
    this.setState({ categories });
  };

  handleAddSkill = categoryId => {
    const categories = this.state.categories;
    const categoryIndex = findIndex(categories, categoryId);

    categories[categoryIndex].skills.push({
      _id: `_${new Date().getTime()}`,
      name: ""
    });
    this.setState({ categories });
  };

  handlerDeleteCategory = categoryId => {
    if (!confirm("Are you sure you want to delete this category ?")) {
      return;
    }

    const { categories } = this.state;
    const categoryIndex = findIndex(categories, categoryId);

    if (categories[categoryIndex]._id) {
      categories.splice(categoryIndex, 1);
    } else {
      categories[categoryIndex]._destroy = true;
    }

    this.setState({ categories });
  };

  handleDeleteSkill = (categoryId, skillId) => {
    const categories = this.state.categories;
    const categoryIndex = findIndex(categories, categoryId);
    const skillIndex = findIndex(categories[categoryIndex].skills, skillId);

    if (categories[categoryIndex].skills[skillIndex]._id) {
      categories[categoryIndex].skills.splice(skillIndex, 1);
    } else {
      categories[categoryIndex].skills[skillIndex]._destroy = true;
    }

    this.setState({ categories });
  };

  handleSave = () => {
    const { editCategoryId } = this.props;
    const { categories } = this.state;
    const data = categories.map(category => ({
      id: category.id,
      name: category.name,
      _destroy: category._destroy,
      in_service_category_skills_attributes: category.skills.map(skill => ({
        id: skill.id,
        name: skill.name,
        _destroy: skill._destroy
      }))
    }));
    const attr = {
      edit_category_id: editCategoryId,
      in_service_categories_attributes: data
    };

    this.setState({ loading: true });
    axios
      .post("/in_services/categories", attr)
      .then(({ data }) => {
        toastr.success("Category updated");

        this.setState({ loading: false, categories: data.categories });
      })
      .catch(this.handleError);
  };

  handleError = ({ response }) => {
    this.setState({ loading: false });

    if (response && response.data && response.data.messages) {
      const { messages } = response.data;
      const tmp = [];
      if (messages["in_service_categories.in_service_category_skills"]) {
        tmp.push(`Category ${messages["in_service_categories.in_service_category_skills"].join(", ")}`);
      }
      if (messages["in_service_categories.name"]) {
        tmp.push(`Category ${messages["in_service_categories.name"].join(", ")}`);
      }
      if (messages["in_service_categories.in_service_category_skills.name"]) {
        tmp.push(`Skill ${messages["in_service_categories.in_service_category_skills.name"].join(", ")}`);
      }

      if (tmp.length) {
        toastr.error(tmp.join("<br/>"));
      }
    }
  };

  render() {
    const { editCategoryId } = this.props;
    const { categories, loading } = this.state;
    const len = categories.length - 1;

    return (
      <div className="in-service-categories">
        <h1>In-Service Category</h1>

        <div className="u-form-width-fix well shadowDepth1">
          {categories
            .filter(c => !c._destroy)
            .map((item, index) => (
              <Category
                key={item.id || item._id}
                category={item}
                isLast={len === index}
                onChangeCategoryName={this.handleChangeCategoryName}
                onChangeSkillName={this.handleChangeSkillName}
                onAddSkill={this.handleAddSkill}
                onDeleteCategory={this.handlerDeleteCategory}
                onDeleteSkill={this.handleDeleteSkill}
              />
            ))}

          {editCategoryId ? null : (
            <button
              className="btn btn-indigo btn-raised btn-long"
              onClick={this.handleAddCategory}
            >
              ADD CATEGORY
            </button>
          )}

          <br />
          <br />
          <button
            disabled={loading}
            className="btn btn-pink btn-raised btn-block"
            onClick={this.handleSave}
          >
            SAV{loading ? "ING..." : "E"}
          </button>
        </div>
      </div>
    );
  }
}

Categories.propTypes = {
  categories: PropTypes.array.isRequired,
  editCategoryId: PropTypes.string
};

export default Categories;
